import { render } from "./MarketListItem.vue?vue&type=template&id=113eda8d&scoped=true"
import script from "./MarketListItem.vue?vue&type=script&lang=js"
export * from "./MarketListItem.vue?vue&type=script&lang=js"

import "./MarketListItem.vue?vue&type=style&index=0&id=113eda8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113eda8d"]])

export default __exports__